export function Step3Icon2() {
    return (
        <svg width="47" height="57" viewBox="0 0 47 57" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M1.00116 13.137C0.956325 16.4364 2.21645 19.6206 4.50862 22H16.5162C16.6818 20.6714 17.1934 19.4093 18 18.3392L4.12565 5C2.14204 7.25237 1.03352 10.1393 1.00116 13.137V13.137Z"
                stroke="#9B4DF6"
                strokeWidth="2"
            />
            <path d="M23 15.271V6L15 13.2973L18.8844 17C20.0671 16.0566 21.4923 15.4579 23 15.271Z" stroke="#9B4DF6" strokeWidth="2" />
            <path
                d="M20 23C20 25.2091 21.7909 27 24 27C26.2091 27 28 25.2091 28 23C28 20.7909 26.2091 19 24 19C21.7919 19.0025 20.0025 20.7919 20 23Z"
                stroke="#9B4DF6"
                strokeWidth="2"
            />
            <path d="M42 4.16434C37.0563 -0.0500257 29.9495 -0.0553094 25 4.1517V15.2208C26.455 15.4103 27.8282 16.0274 28.9593 17L42 4.16434Z" stroke="#9B4DF6" strokeWidth="2" />
            <path d="M25 30.7407V40L33 32.6967L29.1243 29C27.9408 29.95 26.5121 30.553 25 30.7407V30.7407Z" stroke="#9B4DF6" strokeWidth="2" />
            <path d="M30 27.6096L42.6784 39C46.6187 34.8061 47.1029 28.6873 43.8654 24H31.5624C31.386 25.3091 30.8476 26.5529 30 27.6096H30Z" stroke="#9B4DF6" strokeWidth="2" />
            <path d="M23 30.6685C21.5449 30.4907 20.1717 29.912 19.0407 29L6 41.0333C10.9436 44.9842 18.0504 44.9894 23 41.0457V30.6685Z" stroke="#9B4DF6" strokeWidth="2" />
            <path d="M23 41.7888V56H25V40L24.9189 40.0844C24.3195 40.7078 23.6779 41.2776 23 41.7888H23Z" stroke="#9B4DF6" strokeWidth="2" />
            <path
                d="M30 18.1925C30.8119 19.3115 31.3272 20.6223 31.4967 22H42C41.9953 21.995 41.9908 21.9899 41.986 21.9849L34.3863 14L30 18.1925Z"
                stroke="#9B4DF6"
                strokeWidth="2"
            />
            <path d="M18 27.7746C17.1973 26.665 16.6872 25.3658 16.5179 24H6L13.5923 32L18 27.7746Z" stroke="#9B4DF6" strokeWidth="2" />
        </svg>
    )
}
